module.exports = __webpack_public_path__ + "img/banner.2bc2a16b.png";